

















































































import { isWishope } from "@/common/utils";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class FilterTab extends Vue {
  @Prop({ type: String, default: null }) readonly selected!: string;
  @Prop({ type: Array, required: false, default: () => [] }) readonly filterList!: Array<{
    label: string;
    value: string;
  }>;

  get isWishope() {
    return isWishope();
  }

  get mainList () {
    return this.filterList.slice(0,4)
  }

  get secondaryList () {
    return this.filterList.slice(4,this.filterList.length)
  }

  get secondaryLabel () {
    const secondary = this.secondaryList.find(({ value }) => value === this.selected)
    return secondary ? secondary.label : this.$t('label.other')
  }

  get selectedSecondary () {
    return this.selected
  }

  set selectedSecondary (value) {
    this.$emit('select', value)
  }
}
